document.addEventListener('click', function (e) {
    if (e.target.closest('.popop-wrapper-event')) {
      let wrapper = e.target.closest('.popop-wrapper-event');
      let thisTargetValue = wrapper.getAttribute('data-popop-event');
      let contentContainer = document.querySelector('.popop-content-container');
      let bodyWrapper = document.querySelector('html');
  
      if (contentContainer) {
        bodyWrapper.classList.add('overflow-hidden');
        contentContainer.setAttribute('data-popop-event-target', thisTargetValue);
        contentContainer.style.display = 'flex'; 
      }
    }
  
    if (e.target.closest('.popop_close')) {
      let contentContainer = e.target.closest('.popop-content-container');
      let bodyWrapper = document.querySelector('html');
      if (contentContainer) {
        bodyWrapper.classList.remove('overflow-hidden');
        contentContainer.style.display = 'none'; 
      }
    }
  });
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#loyalty-signup-popop"]');
    if (link) {
      e.preventDefault();
      document.documentElement.classList.add('overflow-hidden');
      const popup = document.querySelector('[data-popop="loyalty-signup-popop"]');
      if (popup) {
        popup.style.display = 'flex';
      }
    }
  });
  document.addEventListener('click', function (e) {
    const Opt_link = e.target.closest('.js-opt-out-pop');
    if (Opt_link) {
      e.preventDefault();
      document.documentElement.classList.add('overflow-hidden');
      const Opt_popup = document.querySelector('[data-popop="Opt-out-confirmed"]');
      if (Opt_popup) {
        Opt_popup.style.display = 'flex';
      }
    }
  });
  document.addEventListener('click', function (e) {
    // --- Close popup ---
    if (e.target.closest('.js-pop-close')) {
      document.documentElement.classList.remove('overflow-hidden');
  
      document.querySelectorAll('.js-block-event').forEach(el => {
        el.classList.remove('active_block');
      });
  
      const popup = e.target.closest('.js-block-popop');
      if (popup) popup.style.display = 'none';
    }
  
    // --- Open popup ---
    else if (e.target.closest('.js-block-event:not(.active_block)')) {
      const block = e.target.closest('.js-block-event:not(.active_block)');
      if (!block) return;
  
      document.documentElement.classList.add('overflow-hidden');
      const popLink = block.getAttribute('data-pop');
      block.classList.add('active_block');
  
      const popup = document.querySelector(`.js-block-popop[data-pop-target="${popLink}"]`);
      if (popup) popup.style.display = 'flex';
    }
  
    // --- Click on backdrop (close) ---
    else if (e.target.classList.contains('js-block-popop')) {
      document.documentElement.classList.remove('overflow-hidden');
      e.target.style.display = 'none';
  
      document.querySelectorAll('.js-block-event').forEach(el => {
        el.classList.remove('active_block');
      });
    }
  });
  document.addEventListener('click', function (e) {
    // --- Open loyalty signup popup ---
    const joinBtn = e.target.closest('.join-hawkstone-loyalty-popop');
    if (joinBtn) {
      e.preventDefault();
  
      const parentContainer = joinBtn.closest('.popop-content-container');
      if (parentContainer) parentContainer.style.display = 'none';
  
      const loyaltyPopup = document.querySelector('[data-popop="loyalty-signup-popop"]');
      if (loyaltyPopup) loyaltyPopup.style.display = 'flex';
    }
  
    // --- Close loyalty signup popup ---
    const closeBtn = e.target.closest('.custom-popop_close, .clospop');
    if (closeBtn) {
      e.preventDefault();
      document.documentElement.classList.remove('overflow-hidden');
      const loyaltyPopup = document.querySelector('[data-popop="loyalty-signup-popop"]');
      if (loyaltyPopup) loyaltyPopup.style.display = 'none';
    }

    const opt_closeBtn = e.target.closest('.js-custom-popop_close, .js-clospop');
    if (opt_closeBtn) {
      e.preventDefault();
      document.documentElement.classList.remove('overflow-hidden');
      const opt_loyaltyPopup = document.querySelector('[data-popop="Opt-out-confirmed"]');
      const opt_loyaltyPopupCheckbox = document.querySelector('#opt-out-loyal .styled-checkbox');
      const opt_loyaltyPopupbutton = document.querySelector('.opt-del-button');
      if (opt_loyaltyPopup) opt_loyaltyPopup.style.display = 'none';
      if (opt_loyaltyPopupCheckbox.checked){
        opt_loyaltyPopupCheckbox.checked = false;
        opt_loyaltyPopupbutton.setAttribute('disabled', 'disabled');
        opt_loyaltyPopupbutton.classList.remove('opt_btn-confirmed');
      }
      
    }
  });
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.benefit_btn');
    if (!btn) return;
  
    const btnID = btn.getAttribute('data-link');
  
    // Remove 'active' from siblings
    const siblings = btn.parentElement ? Array.from(btn.parentElement.children) : [];
    siblings.forEach(sib => {
      if (sib !== btn) sib.classList.remove('active');
    });
  
    // Add 'active' to clicked button
    btn.classList.add('active');
  
    // Find all grid items in the same .custom-benefits-grid
    const grid = btn.closest('.custom-benefits-grid');
    if (!grid) return;
  
    const gridItems = Array.from(grid.querySelectorAll('.custom-benefits-grid-item'));
  
    // Hide all items
    gridItems.forEach(item => {
      item.style.display = 'none';
    });
  
    // Show items matching data-target-1, data-target-2, or data-target-3
    gridItems.forEach(item => {
      if (
        item.getAttribute('data-target-1') === btnID ||
        item.getAttribute('data-target-2') === btnID ||
        item.getAttribute('data-target-3') === btnID
      ) {
        item.style.display = 'block';
      }
    });
  });
  document.addEventListener('click', function (e) {
    // --- Popup button for non-login ---
    const popupBtn = e.target.closest('.popup-button-non-login');
    if (popupBtn) {
      const warningMsg = document.querySelectorAll('.warning-message');
      warningMsg.forEach(msg => {
        msg.style.opacity = 0;
        msg.style.display = 'block';
        // Fade in
        let opacity = 0;
        const fadeIn = setInterval(() => {
          opacity += 0.1;
          if (opacity >= 1) {
            opacity = 1;
            clearInterval(fadeIn);
          }
          msg.style.opacity = opacity;
        }, 30);
  
        // Fade out after 5s
        setTimeout(() => {
          let fadeOpacity = 1;
          const fadeOut = setInterval(() => {
            fadeOpacity -= 0.05;
            if (fadeOpacity <= 0) {
              fadeOpacity = 0;
              clearInterval(fadeOut);
              msg.style.display = 'none';
            }
            msg.style.opacity = fadeOpacity;
          }, 30);
        }, 5000);
      });
  
      // Redirect after 3s
      setTimeout(() => {
        window.location.href = '/account/login';
      }, 3000);
    }
  });
  
  // --- Checkbox change handling ---
  document.addEventListener('change', function (e) {
    const checkbox = e.target.closest('#loyalty-enroll .styled-checkbox');
    if (!checkbox) return;
  
    const customBtn = document.querySelectorAll('.custom-pop-button');
    const warningMsg = document.querySelectorAll('.warning-message');
  
    if (checkbox.checked) {
      customBtn.forEach(btn => btn.removeAttribute('disabled'));
      warningMsg.forEach(msg => (msg.style.display = 'none'));
    } else {
      customBtn.forEach(btn => btn.setAttribute('disabled', 'disabled'));
      warningMsg.forEach(msg => (msg.style.display = 'block'));
    }
  });
  document.addEventListener('change', function (e) {
    const checkbox = e.target.closest('#opt-out-loyal .styled-checkbox');
    if (!checkbox) return;
  
    const OptcustomBtn = document.querySelectorAll('.opt-del-button');
    // const OptwarningMsg = document.querySelectorAll('.custom-popop-content');
  
    if (checkbox.checked) {
      OptcustomBtn.forEach(btn => {
        btn.removeAttribute('disabled');
        btn.classList.add('opt_btn-confirmed');
      });
    } else {
      OptcustomBtn.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.remove('opt_btn-confirmed');
      });
      
    }
  });
  document.addEventListener('click', function (e) {
    // --- Rune tabs click ---
    const tabBtn = e.target.closest('.rune-tabs-event');
    if (tabBtn) {
      const tabID = tabBtn.getAttribute('data-tab');
  
      // Remove 'selected' class from siblings
      const siblings = tabBtn.parentElement ? Array.from(tabBtn.parentElement.children) : [];
      siblings.forEach(sib => {
        if (sib !== tabBtn) sib.classList.remove('selected');
      });
  
      // Add 'selected' to clicked tab
      tabBtn.classList.add('selected');
  
      // Find all tab contents in the same .rune-all-box
      const container = tabBtn.closest('.rune-all-box');
      if (!container) return;
  
      const contents = Array.from(container.querySelectorAll('.rune-tabs-content'));
      contents.forEach(content => {
        content.style.display = 'none';
        if (content.getAttribute('data-tab-content') === tabID) {
          content.style.display = 'block';
        }
      });
    }
  
    // --- Login button click ---
    const loginBtn = e.target.closest('.login__button');
    if (loginBtn) {
      e.preventDefault();
      window.location.href = '/account/login';
    }
  });
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-event-copy-value');
    if (!btn) return;
  
    const textToCopy = btn.dataset.copy || btn.textContent.trim();
  
    // Copy text using Clipboard API or fallback
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => showCopiedMsg(btn))
        .catch(err => console.error('Clipboard error:', err));
    } else {
      const tempTextarea = document.createElement('textarea');
      tempTextarea.value = textToCopy;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextarea);
      showCopiedMsg(btn);
    }
  
    // Function to show fading "Copied" message
    function showCopiedMsg(el) {
      // Remove any existing message
      const existingMsg = el.querySelector('.copy-message');
      if (existingMsg) existingMsg.remove();
  
      // Create message element
      const msg = document.createElement('span');
      msg.className = 'copy-message';
      msg.textContent = 'Copied!';
  
      // Style message
      Object.assign(msg.style, {
        position: 'absolute',
        background: '#000',
        color: '#fff',
        padding: '3px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        top: '-25px',
        left: '50%',
        transform: 'translateX(-50%)',
        opacity: '0',
        transition: 'opacity 0.3s ease, top 0.3s ease',
        whiteSpace: 'nowrap',
        zIndex: 9999,
        pointerEvents: 'none'
      });
  
      el.appendChild(msg);
  
      // Animate in
      requestAnimationFrame(() => {
        msg.style.opacity = '1';
        msg.style.top = '-35px';
      });
  
      // Fade out after 1.5s
      setTimeout(() => {
        msg.style.opacity = '0';
        msg.style.top = '-25px';
        setTimeout(() => {
          msg.remove();
        }, 400);
      }, 1500);
    }
  });
  
